var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticStyle:{"color":"#000"}},[_vm._v("Forgot Password Screen")])
}
var staticRenderFns = []

export { render, staticRenderFns }